import apiCommonCategory from "@/api/common-category";
import {post} from "@/utils/request";

export default class apiBkCompany extends apiCommonCategory{
  static module = "bk_company";

  static async getInfo(){
    return post('/home/bk_company/getInfo')
  }

  static async save(data){
    return post('/home/bk_company/save', data)
  }
}
